import React from "react";
import SectionHeader from "../Common/Section-Header/SectionHeader";
import ContactForm from "./Contact-Form/ContactForm";
import Fade from "react-reveal/Fade";
import "./Contact.scss";

const Contact = () => {
  return (
    <section className="section-separator" id="contact">
      <div className="container mb-5">
        <Fade bottom>
          <SectionHeader subtitle="Let's Connect !" title="Contact Me" />
        </Fade>

        <div className="row mt-5">
          <Fade bottom>
            <div className="col-lg-5">
              <div className="contact-about-area">
                <div className="thumbnail">
                  <img
                    loading="lazy"
                    className="img-fluid"
                    src="https://i.ibb.co/C1HBTFN/contact3.gif"
                    alt="contact"
                  />
                </div>
                <p className="description">
                  Connect with me on social media and route all the queries to
                  email.
                </p>
                <div className="social-links">
                  <p className="info d-flex align-items-center">
                    <i className="bi bi-telephone">&nbsp;</i> (+94)74 028 ***2
                  </p>
                  <p className="info d-flex align-items-center">
                    <i className="bi bi-envelope">&nbsp;</i>
                    nandundiaz.info@gmail.com
                  </p>
                  <p className="info d-flex align-items-center">
                    <i className="bi bi-chat-left-text">&nbsp;</i>{" "}
                    <a
                      href="https://www.linkedin.com/in/nandundiaz/"
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        textDecoration: "none",
                        color: "inherit"
                      }}
                    >
                      linkedin.com/in/nandundiaz
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </Fade>

          <Fade bottom>
            <div className="col-lg-7">
              <ContactForm />
            </div>
          </Fade>
        </div>
      </div>
    </section>
  );
};

export default Contact;
